import { Link } from "react-router-dom";
import { useSettings } from "../lib/settings";
import { fileUrl } from "../lib/api";
import * as Icons from "lucide-react";

const DEFAULT_QUICK = [
  { label: "الرئيسية", url: "/", is_active: true, order: 0 },
  { label: "المكملات الغذائية", url: "/supplements", is_active: true, order: 1 },
  { label: "الملابس الرياضية", url: "/sportswear", is_active: true, order: 2 },
  { label: "الإكسسوارات", url: "/accessories", is_active: true, order: 3 },
];
const DEFAULT_ACCOUNT = [
  { label: "تسجيل الدخول", url: "/login", is_active: true, order: 0 },
  { label: "إنشاء حساب", url: "/register", is_active: true, order: 1 },
  { label: "سلة التسوق", url: "/cart", is_active: true, order: 2 },
  { label: "طلباتي", url: "/account", is_active: true, order: 3 },
];

const SOCIAL_ICON = {
  instagram: Icons.Instagram, facebook: Icons.Facebook, tiktok: Icons.Music2,
  youtube: Icons.Youtube, telegram: Icons.Send, x: Icons.Twitter, custom: Icons.Globe,
};

function renderLink(l, i) {
  const isExternal = /^https?:\/\//.test(l.url || "");
  const props = l.new_tab || isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {};
  if (isExternal) return <li key={i}><a href={l.url} {...props} className="hover:text-[#EF1B17]">{l.label}</a></li>;
  return <li key={i}><Link to={l.url || "/"} {...props} className="hover:text-[#EF1B17]">{l.label}</Link></li>;
}

export default function Footer() {
  const { settings: s = {} } = useSettings();
  const brandName = s.footer_brand_name || s.store_name || "POWER GYM";
  const brandLogo = (s.footer_use_site_logo === false ? s.footer_logo_url : (s.footer_logo_url || s.logo_url)) || "";
  const brandDesc = s.footer_description || "متجرك الرياضي الموثوق لكل ما تحتاجه من مكملات وملابس وإكسسوارات.";
  const showBrand = s.footer_show_brand !== false;
  const quick = (s.footer_quick_links?.length ? s.footer_quick_links : DEFAULT_QUICK).filter((l) => l.is_active !== false).sort((a,b)=>(a.order||0)-(b.order||0));
  const account = (s.footer_account_links?.length ? s.footer_account_links : DEFAULT_ACCOUNT).filter((l) => l.is_active !== false).sort((a,b)=>(a.order||0)-(b.order||0));
  const socials = (s.footer_socials || Object.entries(s.social || {}).map(([type, url]) => ({ type, url, label: type, is_active: !!url, order: 0 }))).filter((x) => x.is_active !== false && x.url);
  const showCopyright = s.footer_show_copyright !== false;
  const year = s.footer_year || new Date().getFullYear();
  const copyText = s.footer_copyright || `© ${year} ${brandName}. جميع الحقوق محفوظة.`;
  const phone = s.phone, whatsapp = s.whatsapp, address = s.address, email = s.email;
  const showPhone = s.footer_show_phone !== false;
  const showWhatsapp = s.footer_show_whatsapp !== false;
  const showAddress = s.footer_show_address !== false;
  const showEmail = s.footer_show_email !== false;

  return (
    <footer data-testid="site-footer" className="mt-24 border-t-2 border-[#EF1B17] bg-[#191A1D]">
      <div className="pg-container py-12 md:py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        {showBrand && (
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              {brandLogo ? (
                <img src={fileUrl(brandLogo)} alt={brandName} className="w-10 h-10 rounded-md object-contain bg-[#24262B] border border-[#3A3D43] p-0.5" />
              ) : (
                <div className="w-10 h-10 rounded-md bg-gradient-to-br from-[#EF1B17] to-[#FF3B30] flex items-center justify-center font-black text-white">{brandName.slice(0,2).toUpperCase()}</div>
              )}
              <span className="font-black text-xl">{brandName}</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">{brandDesc}</p>
          </div>
        )}
        {quick.length > 0 && (
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-4">روابط سريعة</h4>
            <ul className="space-y-2 text-sm">{quick.map(renderLink)}</ul>
          </div>
        )}
        {account.length > 0 && (
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-4">حسابي</h4>
            <ul className="space-y-2 text-sm">{account.map(renderLink)}</ul>
          </div>
        )}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-4">تواصل معنا</h4>
          <ul className="space-y-2 text-sm text-gray-300">
            {showPhone && phone && <li className="flex items-center gap-2"><Icons.Phone size={14} /> <a href={`tel:${phone.replace(/\s/g,'')}`} className="hover:text-[#EF1B17]">{phone}</a></li>}
            {showWhatsapp && whatsapp && <li className="flex items-center gap-2"><Icons.MessageCircle size={14} /> <a href={`https://wa.me/${whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#EF1B17]">{whatsapp}</a></li>}
            {showEmail && email && <li className="flex items-center gap-2"><Icons.Mail size={14} /> {email}</li>}
            {showAddress && address && <li>{address}</li>}
          </ul>
          {socials.length > 0 && (
            <div className="flex gap-3 mt-4">
              {socials.sort((a,b)=>(a.order||0)-(b.order||0)).map((soc, i) => {
                const Ic = SOCIAL_ICON[soc.type] || Icons.Globe;
                return (
                  <a key={i} href={soc.url} target={soc.new_tab !== false ? "_blank" : undefined} rel="noopener noreferrer"
                    aria-label={soc.label || soc.type}
                    className="w-9 h-9 rounded-md border border-[#3A3D43] flex items-center justify-center hover:border-[#EF1B17] hover:text-[#EF1B17]"><Ic size={16} /></a>
                );
              })}
            </div>
          )}
        </div>
      </div>
      {showCopyright && (
        <div className="border-t border-[#3A3D43]/60 py-5 text-center text-xs text-gray-500">{copyText}</div>
      )}
    </footer>
  );
}
